module.exports = __webpack_public_path__ + "img/header-3.b47704d.jpeg";